import { FormSelect } from '../FormSelect';
import { COUNTRY_OPTIONS } from '../../../utils/countries';
import React from 'react';
import PropTypes from 'prop-types';

export const FormCountrySelect = ({ name, label, ...props }) => <FormSelect name={name} label={label} options={COUNTRY_OPTIONS} isSearchable isClearable {...props} />;

FormCountrySelect.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string
};
